import { render } from "./kubevirt-migration.vue?vue&type=template&id=20dcf50c&scoped=true"
import script from "./kubevirt-migration.vue?vue&type=script&lang=js"
export * from "./kubevirt-migration.vue?vue&type=script&lang=js"

import "./kubevirt-migration.vue?vue&type=style&index=0&id=20dcf50c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dcf50c"]])

export default __exports__